import { UserRole } from "@joonapp/web-shared"

import { MissionGroup } from "../../types"
import { createJoonAPIClient } from "../../util/joon-api"

export const getMissions = async (userId: number) => {
  const API = createJoonAPIClient()

  const response = await API.get<{ results: MissionGroup[] }>("api/missions/", {
    params: {
      user_id: userId,
      role: UserRole.PARENT,
    },
  })

  return response.data?.results?.[0]?.missions
}
